<template>
	<div class="col-12 mb-3">
		<div class="card mt-3 w-100">
			<h5
				class="card-header devices-header d-flex justify-content-between align-items-center"
				style="cursor: pointer"
				@click="collapsed = !collapsed"
			>
				<span><i class="fas fa-cloud-download-alt mr-2"></i> Connect Your Devices</span>
				<i class="fas" :class="collapsed ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
			</h5>

			<b-collapse v-model="collapsed">
				<div v-if="isLoading == 1" class="text-center">
					<i class="fas fa-spinner fa-spin fa-2x p-2"></i>
				</div>

				<div class="card-body">
					<b-list-group v-for="stream in visibleStreams" :key="stream.id">
						<b-list-group-item class="mb-2">
							<div class="row">
								<label :for="stream.slug" class="col-12 col-form-label">
									{{stream.title}}
									<button class="px-2 infoModalBtn" v-b-modal="stream.title">
										<i class="fas fa-solid fa-info gold"></i>
									</button>
								</label>
								<b-modal :id="stream.title" :title="stream.title" ok-title="Close" ok-only>
									<div v-html="sanitizeHTML(stream.setup_info)"></div>
									<div v-if="stream.slug == 'fitbit'">
										<p>Click the button below to authorize FitBit API access.</p>
										<b-button @click="fitbitFetchData(stream)">
											Get Latest Data
										</b-button>
									</div>
								</b-modal>
								<div class="col-10">
									<input
										type="text"
										class="form-control mb-1"
										:id="stream.slug"
										:placeholder="stream.token_name"
										v-model="stream.api_user_id"
										@keyup="streamClassChange(stream, 2)"
									/>
								</div>
								<div class="col-2 text-right" v-if="stream.class != ''">
									<button
										type="button"
										class="btn btn-sm"
										:class="stream.class"
										@click="UpdateStreamSettings(stream)"
									>
										<span v-if="stream.class == 'btn-primary'">Save</span>
									</button>
								</div>
							</div>
						</b-list-group-item>
					</b-list-group>
				</div>
			</b-collapse>
		</div>
	</div>
</template>

<script>
import axios from '@/axios';
import DOMPurify from 'dompurify';
export default {
	props: {
		profileid: null,
	},
	computed: {
		visibleStreams() {
			if (!this.streams || typeof this.streams !== 'object') return [];
			return Object.values(this.streams).filter(
				s => s.slug !== 'muse' && s.slug !== 'focusband'
			);
		},
	},
	data() {
		return {
			isLoading: 1,
			collapsed: false,
			streams: {},
			errors: {
				email: "",
				email_class: "text-danger",
			},
			email: null,
			processing: 0,
		};
	},
	mounted() {
		this.getDataStreams();
	},

	methods: {
		sanitizeHTML(html) {
			return DOMPurify.sanitize(html);
		},
		getDataStreams() {
			let _this = this;
			let params = new URLSearchParams();
      if (this.profileid) {
        params.append('user_id', this.profileid);
      }
			axios({
				url: 'dataStreamsGet',
				params: params,
			})
				.then(function (response) {
					if (response.data.status == 1) {
						_this.streams = response.data.streams;
					} else {
						_this.streams = null;
					}
					_this.isLoading = 0;
				})
				.catch(function () {});
		},

		streamClassChange(item, status) {
			if (status == 3) {
				item.class = '';
				item.icon = '';
			} else if (item.value != item.api_user_id) {
				item.class = 'btn-primary';
				item.icon = 'far fa-hand-point-down';
			} else if (status == 1) {
				item.class = 'text-success';
				item.icon = 'fas fa-check';
			} else if (status == -1) {
				item.class = 'text-danger';
				item.icon = 'fas fa-times';
			} else {
				item.class = '';
				item.icon = '';
			}

			return item;
		},

		UpdateStreamSettings(stream) {
			let _this = this;

			stream.class = 'text-success';
			stream.icon = 'fas fa-spinner fa-spin';

			let params = new URLSearchParams();
      if (this.profileid) {
        params.append('user_id', this.profileid);
      }
			params.append('data_stream_settings_id', stream.user_data_id);
			params.append('data_stream_id', stream.id);
			params.append('value', stream.api_user_id);
			axios({
				url: _this.$store.state.api_url + 'dataStreamSet',
				params: params,
			})
				.then(function (response) {
					if (response.data.status == 1) {
						stream.user_data_id = response.data.data_stream_settings_id;
						stream = _this.streamClassChange(stream, 3);
					} else {
						stream = _this.streamClassChange(stream, -1);
					}
				})
				.catch(function () {});
		},
		fitbitFetchData(item) {
			var link = item.auth_link + this.$store.state.session_id;
			window.location.href = link;
			item.processing = 1;
			let _this = this;
			let params = new URLSearchParams();
			params.append('token', this.$store.getters.userTokenGet);
			params.append('user_id', this.profile.id);

			axios({
				url: _this.$store.state.env.api_url + 'fitbitUserData_Fetch',
				params: params,
			})
				.then(function (response) {
					item.processing = 0;
					item.message = response.data.message;
					if (response.data.status === 1) {
						item.last_updated = response.data.last_updated;
					}
				})
				.catch(function (e) {
					console.log('Error userDevicesGet:' + e);
				});
		},
	},
};
</script>

<style scoped>
.devices-header {
	background: linear-gradient(90deg, rgba(214,182,116,0.12) 0%, rgba(214,182,116,0.03) 100%);
	border-left: 4px solid #d6b674;
	color: #444;
	font-weight: 600;
	font-size: 1rem;
}

@media (max-width: 800px) {
	.devices-header {
		font-size: 0.82rem;
	}
}

.infoModalBtn {
	background-color: inherit;
	border: none;
}

.infoModalBtn:focus {
	outline: none;
}
</style>
